module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("Reset your password")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrong_state),
      expression: "wrong_state"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.wrong_words))]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email Adress"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": [_vm.check_val, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix btns"
  }, [_c('a', {
    staticClass: "continue",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back_login
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-655e05f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/forgot_password/forgot_password_step1.vue
// module id = 851
// module chunks = 1